import React, { useState } from 'react';
import { Box, Button, Grid, Typography } from '@mui/material';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import { useAuth } from 'react-oidc-context';
import { EnvioNacionalModal } from '../../../venta/presentation/components/EnvioNacionalModal/EnvioNacionalModal';
import { EnvioNacionalForm } from '../../../venta/presentation/components/EnvioNacionalModal/EnvioNacionalModal.types';
import { CarritoVentaPanel } from '../../../venta/presentation/components/CarritoVentaPanel';
import { CotizacionLigeroModal } from '../components/CotizacionLigeroModal';

export const CotizacionPage: React.FC = () => {
  const auth = useAuth();
  const accessToken = auth.user?.access_token ?? '';
  const [ligeroOpen, setLigeroOpen] = useState(true);
  const [wizardOpen, setWizardOpen] = useState(false);
  const [wizardForm, setWizardForm] = useState<EnvioNacionalForm | undefined>();

  const handleCrearGuia = (form: EnvioNacionalForm) => {
    setLigeroOpen(false);
    setWizardForm(form);
    setWizardOpen(true);
  };

  const handleWizardClose = () => {
    setWizardOpen(false);
    setWizardForm(undefined);
  };

  return (
    <Box sx={{ p: 3, height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Grid container spacing={3} sx={{ flexGrow: 1, height: '100%' }}>
        <Grid size={{ xs: 12, md: 8 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
            <RequestQuoteIcon color="primary" />
            <Typography variant="h5" sx={{ fontWeight: 700 }}>
              Cotizar
            </Typography>
          </Box>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Consulta la tarifa con origen, destino y paquete. Crear Guía abre la guía nacional;
            el envío entra al carrito al confirmar.
          </Typography>
          <Button
            variant="contained"
            onClick={() => setLigeroOpen(true)}
            sx={{ fontWeight: 'bold', borderRadius: 8 }}
          >
            Cotizar envío
          </Button>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }} sx={{ height: '100%' }}>
          <CarritoVentaPanel emptyMessage="Aún no hay envíos en el carrito. Cotiza un envío para comenzar." />
        </Grid>
      </Grid>
      <CotizacionLigeroModal
        open={ligeroOpen}
        onClose={() => setLigeroOpen(false)}
        accessToken={accessToken}
        onCrearGuia={handleCrearGuia}
      />
      <EnvioNacionalModal
        open={wizardOpen}
        onClose={handleWizardClose}
        accessToken={accessToken}
        initialForm={wizardForm}
        initialStep={0}
      />
    </Box>
  );
};
